import { createContext } from "react";

import type { ModalDialogContextProps } from "../modal-dialog.types";

export const ModalDialogContext = createContext<ModalDialogContextProps>({
  onClose: () => {},
});
